export default "__VITE_ASSET__4388a4f2__"